import type { AiModelPayload } from '@Application/Ai/AiConfiguration/Models/Actions/aiModelsFetched';

export type AiModelCreatedPayload = AiModelPayload;

export type AiModelCreatedAction = {
	type: 'AI_MODEL_CREATED';
	payload: AiModelCreatedPayload;
	accountId: number;
};

export default (payload: AiModelCreatedPayload, accountId: number): AiModelCreatedAction => ({
	type: 'AI_MODEL_CREATED',
	payload,
	accountId,
});
